import { render, staticRenderFns } from "./Postchoose.vue?vue&type=template&id=6c926cde&scoped=true"
import script from "./Postchoose.vue?vue&type=script&lang=js"
export * from "./Postchoose.vue?vue&type=script&lang=js"
import style0 from "./Postchoose.vue?vue&type=style&index=0&id=6c926cde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c926cde",
  null
  
)

export default component.exports